<template>
  <div>
    <field-item
      v-for="field in section.fields"
      :key="field.id"
      :disabled="handler.isDisabled(field, parentTreeContext)"
      @click="select(section.select(field, ...selectAdditionalParameters))"
    >
      <row>
        <prefix>
          <icon :glyph="iconGlyph"/>
        </prefix>
        <column>
          {{field.label}}
        </column>
      </row>
    </field-item>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import handlerComponentsMixin from '~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin';
  import FieldItem from './field-item.vue';
  import DynamicFieldsHandler from "~/models/dynamicFields/handlers/dynamicFieldsHandler";
  import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin'

  export default Vue.extend({
    mixins: [
      handlerComponentsMixin,
      handlerTreeContextMixin,
    ],
    components: {
      FieldItem,
    },
    props: {
      handler: {
        type: Object as () => DynamicFieldsHandler,
        required: true,
      },
      section: {
        required: true,
      },
      iconGlyph: {
        // this could probably be handled in a different way
        type: String,
        required: true,
      },
      selectAdditionalParameters: {
        type: Array,
        default: []
      }
    },
    computed: {
    },
    methods: {
    },
  });
</script>